import LoyaltyAvatarPageContainer from "containers/pages/LoyaltyAvatarPageContainer";
import { LoyaltyListRewardsRedesignContainer } from "containers/organisms/LoyaltyListRewardsRedesignContainer";
import { LoyaltyGetRewardsContainer } from "containers/organisms/LoyaltyGetRewardsContainer";
import { LoyaltyContentProps } from "components/atoms/LoyaltyContent";
import { LoyaltyTabs } from "constants/loyalty";
import { LoyaltyMoreRewardsContainer } from "../../../containers/organisms/LoyaltyMoreRewardsContainer";

export const LoyaltyContents = {
  [LoyaltyTabs.REWARDS]: (
    <>
      <LoyaltyListRewardsRedesignContainer />
      <LoyaltyMoreRewardsContainer />
    </>
  ),
  [LoyaltyTabs.INFO]: <LoyaltyGetRewardsContainer />,
  [LoyaltyTabs.AVATAR]: <LoyaltyAvatarPageContainer />,
};

export const LoyaltyButtonTabs: LoyaltyContentProps<LoyaltyTabs>["buttons"] = [
  {
    keyTranslate: "loyalty.title.bonusRewards",
    value: LoyaltyTabs.REWARDS,
  },
  {
    keyTranslate: "loyalty.tab.how-get",
    value: LoyaltyTabs.INFO,
  },
  {
    keyTranslate: "loyalty.tabs.avatar",
    value: LoyaltyTabs.AVATAR,
  },
];
